var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3695_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1157 23.1228L24.6722 31.8483C24.7562 31.9448 24.8748 32 24.999 32C25.1232 32 25.2419 31.9448 25.3258 31.8483L32.8823 23.1228C33.026 22.9571 33.0399 22.7067 32.9143 22.5248L29.925 18.1885C29.841 18.07 29.7092 18 29.5697 18H20.4319C20.2924 18 20.1606 18.07 20.0766 18.1885L17.0873 22.5248C16.961 22.706 16.9727 22.9564 17.1157 23.1228ZM28.293 23.2752H31.5439L26.1732 29.4763L28.293 23.2752ZM24.999 30.1478L22.6509 23.2752H27.3472L24.999 30.1478ZM24.999 19.2601L27.1092 22.3333L22.8889 22.3326L24.999 19.2601ZM22.1568 21.803L21.1993 18.9301H24.1267L22.1568 21.803ZM25.8712 18.9301H28.7987L27.8411 21.803L25.8712 18.9301ZM21.7037 23.2664L23.8229 29.4687L18.4549 23.2751L21.7037 23.2664ZM31.6798 22.3237H28.6086L29.6085 19.3072L31.6798 22.3237ZM20.3805 19.3242L21.3804 22.3407H18.3183L20.3805 19.3242Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3695_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav_icon_3.dceab2cb33575eeb3c973ac91be7823b.svg";
export { ForwardRef as ReactComponent };